import table from '../inputSearch'

 const commoninputSearch = {
    install:function(Vue) {
        Vue.component('commoninputSearch', table)
    }
}

// 导出该组件

export default commoninputSearch
